module.exports = __webpack_public_path__ + "fonts/54d9200c4b6903fd803e6469a7d3f0f4.txt";